import React from 'react';
import PropTypes from 'prop-types';
import { LAYERS } from 'bloko/blocks/drop/constants';
import { instanceOfDOMNodeOrNull } from 'bloko/common/helpers/customPropTypes';
import DropBase from 'bloko/blocks/drop/Base';

import { defaultProps, MENU_PLACEMENTS, BASE_CLASS_NAMES, BEHAVIOR } from './common';

import './menu.less';

export default function Menu(props) {
    return <DropBase {...props} behavior={BEHAVIOR} baseClassNames={BASE_CLASS_NAMES} closeByClickOutside={true} />;
}

Menu.layers = LAYERS;
Menu.placements = MENU_PLACEMENTS;
Menu.defaultProps = {
    ...defaultProps,
    host: null,
    onClose: () => {},
};
Menu.propTypes = {
    /** Предпочтительное положение меню, доступны в статическом свойстве [placements](#menu-placements). */
    placement: PropTypes.oneOf(Object.values(MENU_PLACEMENTS)),
    /** Выпадать только в заданном направлении, не обрабатывать другие кейсы */
    onlySetPlacement: PropTypes.bool,
    /** Class z-index-а меню, доступны в статическом свойстве [layers](#menu-layers) */
    layer: PropTypes.oneOf(Object.values(LAYERS)),
    /** DOM нода хоста в рамках которого нужно рендерить меню, по дефолту рендер будет в родителе компонента.*/
    host: instanceOfDOMNodeOrNull(),
    /** Флаг отвечает за показ меню, `true` - показать, `false` - скрыть */
    show: PropTypes.bool,
    /** Элемент инициатор, относительно которого показывать меню */
    children: PropTypes.node,
    /** Метод-рендер контента меню */
    render: PropTypes.func.isRequired,
    /** dataQa='bloko-drop-menu' Data-qa активного меню */
    dataQa: PropTypes.string,
    /** Колбек вызываемый при закрытии компонента. Срабатывает в случае клика вне компонента */
    onClose: PropTypes.func,
    /** Метка, использовать ли тянущийся овер.
     * тянущееся меню будет растягивать по контенту, ограничиваясь только размерами экрана */
    flexible: PropTypes.bool,
};
